// ** Angular Import
import { Component } from '@angular/core';

// ** Custom Component Import
import { SectionHeadingComponent } from '@shared/components/core/sections/section-heading/section-heading.component';

// ** Pipe Imports
import { CdnUrlPipe } from '@shared/pipes/cdn-url.pipe';


@Component({
  selector: 'app-about-menu-side-container',
  imports: [
    SectionHeadingComponent,
    CdnUrlPipe
  ],
  templateUrl: './about-menu-side-container.component.html',
  styleUrl: './about-menu-side-container.component.scss'
})

export class AboutMenuSideContainerComponent {
}